// extracted by mini-css-extract-plugin
module.exports = {"container":"chat_container__MuKcZ"};